import styled, { css } from 'styled-components';
import Button from '@nubank/nuds-web/components/Button/Button';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const ModalTriggerButton = styled(Button)`
  ${breakpointsMedia({
    md: css`
      display: none;
    `,
  })}
`;

ModalTriggerButton.displayName = 'ModalTriggerButton';
